<script>
	import router from "page"

	// Include our Routes
	import Home from "./routes/Home.svelte";
	import Login from "./routes/Login.svelte"
	import Error from "./routes/ErrorPage.svelte";
	
	let page;
  	let params;

	// Set up the pages to watch for
	router("/", () => (page = Home));
	router("/login", () => (page = Login));
	router('/*', () => page = Error)

	// Set up the router to start and actively watch for changes
	router.start();

	async function logout()
	{
		let response;

		try
		{
			const response = await fetch(`${window.API_URL}/api/Account/Logout`,
			{
				method: 'POST',
				mode: 'cors',
				credentials: 'include',
				headers:
				{
					'Content-Type': 'application/json'
				}
			});
			
			location.href = "/login";
		}
	
		catch(ex)
		{
			console.log(ex);
		}
	}
</script>

<div class="columns">
	<div class="column col-12">
	  <div class="navbar">
		<div class="navbar-section"></div>
		<div class="navbar-center"><a class="btn btn-link" href="/"><img src="logo.png" alt="eWATER Logo"></a></div>
		<div class="navbar-section">
			{#if location.pathname != "/login"}
			<button on:click="{logout}" class="btn btn-sm btn-secondary">Logout</button>
			{/if}
		</div>
	  </div>
	</div>
  </div>

<main class="full-height">
	<svelte:component this="{page}" params="{params}" />
</main>